module.exports = __webpack_public_path__ + "img/logo.390376fb.svg";